if (!customElements.get('wishlist-plus-counter')) {
  class WishlistPlusCounter extends HTMLElement {
    connectedCallback() {
      this._updateCount = this._updateCount.bind(this);
      this._onSwymLoaded = this._onSwymLoaded.bind(this);
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(this._onSwymLoaded);
      if (window._swat && window._swat.fetch) {
        this._onSwymLoaded(window._swat);
      }
    }

    _onSwymLoaded(swat) {
      if (!swat || !swat.fetch) return;
      swat.evtLayer.addEventListener(swat.JSEvents.wishlistUpdated, this._updateCount);
      this._fetchCount(swat);
    }

    _fetchCount(swat) {
      swat.fetch(function(data) {
        const count = data ? data.length : 0;
        document.querySelectorAll('.swym-wishlist-count').forEach(function(el) {
          el.textContent = count;
        });
      });
    }

    _updateCount() {
      if (window._swat && window._swat.fetch) {
        this._fetchCount(window._swat);
      }
    }
  }

  customElements.define('wishlist-plus-counter', WishlistPlusCounter);
}

(function() {
  if (!document.querySelector('.swym-add-to-wishlist, #swym-wishlist-render-container')) return;

  var wishlistCache = null;
  var cartVariantIds = new Set();
  var mutationPaused = false;
  var variantCache = {};

  function refreshCart(callback) {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartVariantIds = new Set((cart.items || []).map(function(i) { return i.variant_id; }));
        if (callback) callback();
      })
      .catch(function(err) { console.error('[Wishlist] Cart fetch error:', err); });
  }

  function updateShareBar() {
    var bar = document.getElementById('wishlist-share-bar');
    if (!bar) return;
    if (wishlistCache && wishlistCache.length > 0) {
      bar.removeAttribute('hidden');
    } else {
      bar.setAttribute('hidden', '');
    }
  }

  function refreshCache(swat, callback) {
    swat.fetch(function(data) {
      wishlistCache = data || [];
      updateShareBar();
      if (callback) callback();
    });
  }

  function buildHandleMap() {
    var map = {};
    if (!wishlistCache) return map;
    wishlistCache.forEach(function(item) {
      var handle = item.du.replace(/^.*\/products\//, '').split('?')[0].split('#')[0];
      map[handle] = item;
    });
    return map;
  }

  function syncButtonStates() {
    if (!wishlistCache) return;
    var ids = new Set(wishlistCache.map(function(i) { return String(i.empi); }));
    document.querySelectorAll('.swym-add-to-wishlist').forEach(function(btn) {
      btn.classList.toggle('swym-added', ids.has(btn.dataset.productId));
    });
  }

  function syncCartState(ctaRow) {
    var cartBtn = ctaRow.querySelector('.swym-storefront-layout-grid-item-add-to-cart-button');
    if (!cartBtn) return;
    var content = ctaRow.parentElement;
    var select = content ? content.querySelector('.wishlist-variant-select') : null;
    var variantId = select ? parseInt(select.value, 10) : parseInt(cartBtn.dataset.variantId, 10);
    var inCart = variantId ? cartVariantIds.has(variantId) : false;
    ctaRow.classList.toggle('is-added-to-cart', inCart);
  }

  function syncAllCartStates() {
    document.querySelectorAll('.wishlist-cta-row').forEach(function(row) {
      syncCartState(row);
    });
  }

  function wireRemoveHandlers() {
    if (!wishlistCache) return;
    var handleMap = buildHandleMap();
    document.querySelectorAll('.wishlist-remove-btn[data-handle]').forEach(function(removeBtn) {
      if (removeBtn._wired) return;
      var match = handleMap[removeBtn.dataset.handle];
      if (!match) return;
      removeBtn._wired = true;
      var gridItem = removeBtn.closest('.swym-storefront-layout-grid-item');
      removeBtn.addEventListener('click', function() {
        window._swat.removeFromWishList(
          { empi: match.empi, epi: match.epi, du: match.du },
          function() { if (gridItem) gridItem.remove(); },
          function(err) { console.error('[Wishlist] Error:', err); }
        );
      });
    });
  }

  function fetchVariants(handle, callback) {
    if (variantCache[handle]) {
      callback(variantCache[handle]);
      return;
    }
    fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        variantCache[handle] = product.variants || [];
        callback(variantCache[handle]);
      })
      .catch(function() { callback([]); });
  }

  function extractHandle(item) {
    if (item.dataset.handle) return item.dataset.handle;
    var link = item.querySelector('a.swym-storefront-layout-grid-item-title, a[href*="/products/"]');
    if (!link || !link.href) return null;
    return link.href.replace(/^.*\/products\//, '').split('?')[0].split('#')[0];
  }

  function extractVariantId(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link || !link.href) return null;
    var match = link.href.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  function applyVariantSelect(item, ctaRow) {
    var handle = extractHandle(item);
    if (!handle) return;
    var content = item.querySelector('.swym-storefront-layout-grid-item-content');
    if (!content || content.querySelector('.wishlist-variant-select')) return;

    fetchVariants(handle, function(variants) {
      if (!variants || variants.length <= 1) return;
      if (content.querySelector('.wishlist-variant-select')) return;

      var select = document.createElement('select');
      select.className = 'wishlist-variant-select';

      variants.forEach(function(variant) {
        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        if (!variant.available) option.disabled = true;
        select.appendChild(option);
      });

      var cartBtn = ctaRow.querySelector('.swym-storefront-layout-grid-item-add-to-cart-button');
      var currentVariantId = (cartBtn && cartBtn.dataset.variantId) || extractVariantId(item);
      if (currentVariantId) select.value = currentVariantId;

      select.addEventListener('change', function() {
        syncCartState(ctaRow);
      });

      content.insertBefore(select, ctaRow);
    });
  }

  function applyRemoveButtons() {
    mutationPaused = true;

    var removeLabel = (document.getElementById('wishlist-remove-label') || {}).textContent || 'Remove';

    document.querySelectorAll('.swym-storefront-layout-grid-item').forEach(function(item) {
      var handle = extractHandle(item);
      if (!handle) return;
      var content = item.querySelector('.swym-storefront-layout-grid-item-content');
      if (!content || content.querySelector('.wishlist-cta-row')) return;
      var actionContainer = content.querySelector('.swym-storefront-layout-grid-item-action-container');
      if (!actionContainer) return;

      var removeBtn = document.createElement('button');
      removeBtn.className = 'wishlist-remove-btn';
      removeBtn.textContent = removeLabel;
      removeBtn.dataset.handle = handle;

      var ctaRow = document.createElement('div');
      ctaRow.className = 'wishlist-cta-row';
      content.insertBefore(ctaRow, actionContainer);
      ctaRow.appendChild(actionContainer);
      ctaRow.appendChild(removeBtn);

      syncCartState(ctaRow);
      applyVariantSelect(item, ctaRow);
    });

    mutationPaused = false;
    wireRemoveHandlers();
  }

  document.addEventListener('click', function(e) {
    var cartBtn = e.target.closest('.swym-storefront-layout-grid-item-add-to-cart-button');
    if (!cartBtn) return;
    if (!document.getElementById('swym-wishlist-render-container')) return;

    var content = cartBtn.closest('.swym-storefront-layout-grid-item-content');
    if (!content) return;

    var select = content.querySelector('.wishlist-variant-select');
    if (!select || !select.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var variantId = parseInt(select.value, 10);
    if (!variantId) return;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      cartVariantIds.add(variantId);
      var ctaRow = cartBtn.closest('.wishlist-cta-row');
      if (ctaRow) syncCartState(ctaRow);
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cartVariantIds = new Set((cart.items || []).map(function(i) { return i.variant_id; }));
          document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden), .cart-icon-bubble span:not(.visually-hidden)').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          syncAllCartStates();
        })
        .catch(function() {});
    })
    .catch(function(err) { console.error('[Wishlist] Cart add error:', err); });
  }, true);

  function initWishlistButtons(swat) {
    refreshCart(function() {
      refreshCache(swat, function() {
        syncButtonStates();
        wireRemoveHandlers();
      });
    });

    var debounceTimer;
    applyRemoveButtons();
    var container = document.getElementById('swym-wishlist-render-container');
    if (container) {
      new MutationObserver(function() {
        if (mutationPaused) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          refreshCart(function() {
            applyRemoveButtons();
            syncAllCartStates();
          });
        }, 50);
      }).observe(container, { childList: true, subtree: true });
    }

    swat.evtLayer.addEventListener(swat.JSEvents.wishlistUpdated, function() {
      refreshCache(swat, function() {
        syncButtonStates();
        wireRemoveHandlers();
      });
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.swym-add-to-wishlist');
      if (!btn) return;
      if (!window._swat || !window._swat.addToWishList) return;

      e.preventDefault();
      e.stopPropagation();

      var productId = parseInt(btn.dataset.productId, 10);
      var variantId = parseInt(btn.dataset.variantId, 10);
      var productUrl = btn.dataset.productUrl;
      if (!productId || !variantId) return;

      if (btn.classList.contains('swym-added')) {
        window._swat.removeFromWishList(
          { empi: productId, epi: variantId, du: productUrl },
          function() { btn.classList.remove('swym-added'); },
          function(err) { console.error('[Wishlist] Error:', err); }
        );
      } else {
        window._swat.addToWishList(
          { empi: productId, epi: variantId, du: productUrl },
          function() { btn.classList.add('swym-added'); },
          function(err) { console.error('[Wishlist] Error:', err); }
        );
      }
    });
  }

  function showCopyToast(message) {
    var existing = document.getElementById('wishlist-copy-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'wishlist-copy-toast';
    toast.className = 'wishlist-copy-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      toast.classList.add('wishlist-copy-toast--visible');
    });
    setTimeout(function() {
      toast.classList.remove('wishlist-copy-toast--visible');
      setTimeout(function() { toast.remove(); }, 300);
    }, 2500);
  }

  document.addEventListener('click', function(e) {
    var copyBtn = e.target.closest('.wishlist-share__btn--copy');
    if (!copyBtn) return;
    e.preventDefault();
    var url = copyBtn.dataset.shareUrl;
    if (!url) return;
    var message = copyBtn.dataset.copiedText || '';
    navigator.clipboard.writeText(url).catch(function() {
      var ta = document.createElement('textarea');
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    });
    showCopyToast(message);
  });

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistButtons);
  if (window._swat && window._swat.addToWishList) {
    initWishlistButtons(window._swat);
  }
})();
